// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';

const ContainerCard = ({ children, className }) => <div className={className}> {children}</div>;

export default ContainerCard;

ContainerCard.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
};

ContainerCard.defaultProps = {
  className: 'pad-4-lr pad-2-tb stack-3 dls-gray-02-bg',
};
